import { IdUsuario } from "@/services/common-types"
import { defineStore } from "pinia"

export class SoundPreferences {
    static default() {
        return {
            main: true,
            onSend: true,
            volSend: 50, 
            onReceiveActive: true,
            volReceiveActive: 80, 
            onReceivePassive: true,
            volReceivePassive: 100, 
            onReceiveOnlyMine: false,
        } as SoundPreferences
    }

    constructor(initializer: Partial<SoundPreferences>) {
        this.main              = initializer.main              === undefined ? SoundPreferences.default().main : initializer.main
        this.onSend            = initializer.onSend            === undefined ? SoundPreferences.default().onSend : initializer.onSend
        this.volSend           = initializer.volSend           === undefined ? SoundPreferences.default().volSend : initializer.volSend
        
        this.onReceiveActive   = initializer.onReceiveActive   === undefined ? SoundPreferences.default().onReceiveActive : initializer.onReceiveActive
        this.volReceiveActive  = initializer.volReceiveActive  === undefined ? SoundPreferences.default().volReceiveActive : initializer.volReceiveActive
        
        this.onReceivePassive  = initializer.onReceivePassive  === undefined ? SoundPreferences.default().onReceivePassive : initializer.onReceivePassive
        this.volReceivePassive = initializer.volReceivePassive === undefined ? SoundPreferences.default().volReceivePassive : initializer.volReceivePassive
        
        this.onReceiveOnlyMine = initializer.onReceiveOnlyMine === undefined ? SoundPreferences.default().onReceiveOnlyMine : initializer.onReceiveOnlyMine
    }

    main              :boolean = true
    
    onSend            :boolean = true
    volSend           :number  = 50
    
    onReceiveActive   :boolean = true
    volReceiveActive  :number  = 80
    
    onReceivePassive  :boolean = true
    volReceivePassive :number  = 100
    
    onReceiveOnlyMine :boolean = false
}

export type SoundStore = ReturnType<typeof useSoundStore>
export const useSoundStore = defineStore('sound', {
    state: () => ({
        preferences     : null as null|SoundPreferences,

        onSend          : new Audio('/sounds/send_message.m4a'),
        onReceiveActive : new Audio('/sounds/received_active.m4a'),
        onReceivePassive: new Audio('/sounds/received_passive.m4a'),
    }),
    getters: {

    },
    actions: {
        getLsKey(idUsuario: IdUsuario) {
            return `__sound-prefs-${idUsuario}`;
        },
        updateSoundPreferences(idUsuario: IdUsuario, soundPrefs: SoundPreferences) {
            localStorage.setItem(this.getLsKey(idUsuario), JSON.stringify(soundPrefs));
            this.preferences = soundPrefs;
        },
        getSoundPreferences(idUsuario: IdUsuario): SoundPreferences {
            if (this.preferences) return this.preferences;
            
            const storedStr = localStorage.getItem(this.getLsKey(idUsuario)) || "null";
            const storedPrefs = JSON.parse(storedStr) as null|SoundPreferences || SoundPreferences.default();
            
            const mergedPrefs = new SoundPreferences({ ...SoundPreferences.default(), ...storedPrefs });
            
            this.preferences = mergedPrefs;
            return mergedPrefs;
        },

        playSound(soundId: 'onSend' | 'onReceiveActive' | 'onReceivePassive', isMine?: boolean) {
            if (!this.preferences?.main) return;
            if (this.preferences.onReceiveOnlyMine && !isMine && soundId !== 'onSend') return;

            let audioObj: HTMLAudioElement | null = null;
            let volume = 1.0;

            switch (soundId) {
                case "onSend": 
                    if (!this.preferences.onSend) return; 
                    audioObj = this.onSend;
                    volume = (this.preferences.volSend ?? 50) / 100;
                    break;
                case "onReceiveActive": 
                    if (!this.preferences.onReceiveActive) return; 
                    audioObj = this.onReceiveActive;
                    volume = (this.preferences.volReceiveActive ?? 80) / 100;
                    break;
                case "onReceivePassive": 
                    if (!this.preferences.onReceivePassive) return; 
                    audioObj = this.onReceivePassive;
                    volume = (this.preferences.volReceivePassive ?? 100) / 100;
                    break;
            }

            if (audioObj) {
                audioObj.volume = volume;
                // Reinicia o áudio se já estiver tocando para sons rápidos
                audioObj.currentTime = 0; 
                
                // tratamento 
                void audioObj.play().catch((err) => { 
                    // Ignora erros de autoplay
                    if (process.env.NODE_ENV === 'development') {
                        console.debug('Autoplay prevented:', err);
                    }
                });
            }
        },
    },
})